import { LocationAddress, Origin } from '../../store/queryModels';

export type Destination = LocationAddress;

export type RawLocationData = {
  Destination?: Destination | null;
  Origins?: Origin[];
  Minutes?: number;
  TransportMode?: number;
};

export type FormattedLocationData =
  | {
      calculateTime: true;
      Destination: LocationAddress | null;
      Minutes: number;
      TransportMode: number;
      Origins: Origin[];
      Selected: string | null;
    }
  | 'duplicate id'
  | undefined;

export function formatLocationData(
  data: RawLocationData,
): FormattedLocationData {
  try {
    const notBlank = (value: string | undefined | null): boolean => {
      return value !== null && value !== undefined && value.trim() !== '';
    };

    const formattedAddress = (locationAddress: LocationAddress): string => {
      const parts: (string | undefined | null)[] = [
        `${locationAddress.UnitNumber || ''}` +
          (locationAddress.UnitNumber ? '/' : '') +
          `${locationAddress.StreetNumber || ''} ` +
          `${locationAddress.StreetName || ''}`,
        `${locationAddress.SuburbName || ''} ` +
          `${locationAddress.State || ''} ` +
          `${locationAddress.PostCode || ''}`,
      ];

      return parts
        .filter((value): value is string => notBlank(value))
        .join(', ');
    };

    let destination: LocationAddress | null = null;
    if (data.Destination) {
      const {
        State,
        PostCode,
        StreetNumber,
        StreetName,
        SuburbName,
        Latitude,
        Longitude,
        UnitNumber,
      } = data.Destination;

      destination = {
        State,
        PostCode,
        StreetNumber,
        StreetName,
        SuburbName,
        Latitude,
        Longitude,
        AddressId: (data.Destination as any).AddressId,
        UnitNumber,
        FormattedAddress: formattedAddress(data.Destination),
      };
    }

    let formatedData: any = {
      calculateTime: true,
      Destination: destination,
      Minutes: data.Minutes ?? 30,
      TransportMode: data.TransportMode ?? 1,
      Origins: [],
      Selected: (data as any).Selected ?? null,
    };

    data?.Origins?.forEach((origin) => {
      const {
        State,
        PostCode,
        StreetNumber,
        StreetName,
        SuburbName,
        Latitude,
        Longitude,
        UnitNumber,
      } = origin.Address || {};

      const {
        Minutes,
        UserQueryDetailId,
        HasSchools,
        HasTransports,
        HasSupermarkets,
        DomainUrl,
        REAUrl,
      } = origin as any;

      formatedData.Origins.push({
        UserQueryDetailId,
        Address: {
          State,
          PostCode,
          StreetNumber,
          StreetName,
          SuburbName,
          Latitude,
          Longitude,
          AddressId: (origin.Address as any).AddressId,
          UnitNumber,
          FormattedAddress: formattedAddress(origin.Address),
        },
        Minutes,
        HasSchools,
        HasTransports,
        HasSupermarkets,
        DomainUrl,
        REAUrl,
      });

      if (
        formatedData.Origins.filter(
          (o: any) => o.UserQueryDetailId === UserQueryDetailId,
        ).length > 1
      ) {
        formatedData = 'duplicate id';
      }
    });

    return formatedData;
  } catch (e) {
    console.log(e);
    return undefined;
  }
}

export function minutesToDhms(minutes: number): string {
  if (minutes === 0) {
    return '-';
  }

  minutes = Number(minutes);
  const d = Math.floor(minutes / (60 * 24));
  const h = Math.floor((minutes % (60 * 24)) / 60);
  const m = Math.floor(minutes % 60);
  const mm = ('00' + m).slice(-2);

  if (d > 0) {
    return d + (d === 1 ? ' day ' : ' days ');
  } else {
    return h > 0 ? `${h}:${mm} hs` : `${m} min`;
  }
}
